export default __webpack_public_path__ + "static/media/close.9961c508.svg";